import { useEffect, useState } from 'react';

interface User {
  id: string;
  name: string;
  email: string;
  role: string;
  tenantId?: string;
}

export const DebugInfoPanel = () => {
  const isDev = import.meta.env.DEV;
  const isDemo = import.meta.env.VITE_DEMO_MODE === 'true';

  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    if (!isDev && !isDemo) return;

    const userStr = localStorage.getItem('user');
    if (userStr) {
      try {
        setUser(JSON.parse(userStr));
      } catch (e) {
        console.error('Failed to parse user from localStorage', e);
      }
    }
  }, []);

  // Only show in Dev or Demo environments
  if (!isDev && !isDemo) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 p-4 bg-black/80 text-white rounded-lg text-xs font-mono shadow-lg border border-gray-700 max-w-sm pointer-events-none select-none hover:opacity-10 opacity-70 transition-opacity">
      <h3 className="font-bold text-yellow-400 mb-2 border-b border-gray-600 pb-1">
        Debug Info ({isDemo ? 'Demo' : 'Dev'})
      </h3>
      <div className="space-y-1">
        <div className="flex justify-between gap-4">
          <span className="text-gray-400">DB/Tenant:</span>
          <span className="text-blue-300">{user?.tenantId || 'Context-Based'}</span>
        </div>
        <div className="flex justify-between gap-4">
          <span className="text-gray-400">User:</span>
          <span className="text-green-300">{user?.name || 'Guest'}</span>
        </div>
        <div className="flex justify-between gap-4">
          <span className="text-gray-400">Email:</span>
          <span className="text-gray-300 truncate max-w-[150px]">{user?.email || '-'}</span>
        </div>
        <div className="flex justify-between gap-4">
          <span className="text-gray-400">Role:</span>
          <span className="text-purple-300">{user?.role || '-'}</span>
        </div>
        <div className="flex justify-between gap-4">
          <span className="text-gray-400">Env:</span>
          <span className="text-orange-300">{import.meta.env.MODE}</span>
        </div>
      </div>
    </div>
  );
};
